import { render, staticRenderFns } from "./transmit_mobile.vue?vue&type=template&id=781081d5&"
import script from "./transmit_mobile.vue?vue&type=script&lang=js&"
export * from "./transmit_mobile.vue?vue&type=script&lang=js&"
import style0 from "./transmit_mobile.vue?vue&type=style&index=0&id=781081d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports